var applicationLanguages = {
    bindings : {

    },
    /**
     * @ngInject
     */
    controller : function ApplicationLanguagesCtrl ($scope, $sce, $timeout, userStore) {
        
        var ctrl = this;
        var message;
        ctrl.messages = [];

        function init () {

        }

        function link () {
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Hej! Nu skal du fortælle lidt om, hvilke sprog du taler. Vælg minimum 1 sprog og maksimum 5 🌎'),
                    type: 'receive'
                });
            }, 500);
        }

        function onUserUpdated(data) {
            if(!_.isEmpty(data)) {
                // $timeout(function() {
                //     $location.path('/din-ansoegning');
                // }, 0);
            }   
        }

        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };

        ctrl.$onInit = init;
        ctrl.$postLink = link;

        $scope.$listenTo(userStore, ['user'], onUserUpdated);

    },
    templateUrl: './angular/components/application-languages.component.html',
};